import { memo } from 'react';
import { useRecoilValue } from 'recoil';
import { notificationTypesState } from '../../storage/notifications';
import { EnhancedLabeledSelect } from '../ui/EnhancedLabeledSelect';

type Props = Readonly<{
  type?: string;
  onChange: (type: string) => void;
}>;

function NotificationFilters({ type, onChange }: Props) {
  const notificationTypes = useRecoilValue(notificationTypesState);
  const options =
    notificationTypes?.map((notificationType) => ({
      id: notificationType.internalId,
      label: notificationType.name,
    })) ?? [];

  return (
    <EnhancedLabeledSelect
      label="Tipo:"
      onChange={(e) => onChange((e.option?.id as string) ?? '')}
      options={[
        {
          id: '',
          label: 'Todos',
        },
        ...options,
      ]}
      value={[{ id: type }]}
      onBlurResetsInput
      searchable
      inline
      inset
    />
  );
}

export default memo(NotificationFilters);
